import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import { useForm, useFormState, useWatch } from ".";

const yupSchema = yup.object({
  type: yup.object({
    id: yup.string().required(),
    text: yup.string().required(),
    showOptions: yup.boolean().required(),
  }),
  name: yup.string().required(),
  options: yup.array().test(function testOptions(value) {
    const { type } = this.parent;

    return type?.showOptions ? Boolean(value?.length) : true;
  }),
  description: yup.string().nullable(),
  required: yup.boolean(),
  defaultValue: yup.mixed().nullable(),
});

export function useFormField(defaultValues, onSubmit) {
  const fieldDetails = ["defaultValue", "required", "description"];
  const { required = true } = defaultValues;
  const { control, ...formProps } = useForm({
    mode: "onChange",
    defaultValues: {
      ...(defaultValues.options ? { options: defaultValues.options } : {}),
      required: required,
      type: defaultValues.type,
      name: defaultValues.name,
      defaultValue: defaultValues.defaultValue,
      description: defaultValues.description,
    },
    resolver: yupResolver(yupSchema),
  });
  fieldDetails.forEach(formProps.register);

  const { isDirty, isValid } = useFormState({ control });
  const selectedType = useWatch({ control: control, name: "type" });

  return {
    formProps: { ...formProps, control },
    isReady: isDirty && isValid,
    selectedType: selectedType || defaultValues?.type,
    setFieldDetails: (fields) => {
      fieldDetails.forEach((f) => {
        formProps.setValue(f, fields[f], {
          shouldDirty: true,
          shouldValidate: true,
        });
      });
    },
    handleSubmit: formProps.handleSubmit(async ({ options, ...props }) => {
      const inputtedOptions = selectedType?.showOptions ? { options } : {};
      const resp = await onSubmit({
        ...props,
        ...inputtedOptions,
        type: selectedType.id,
      });

      if (resp) {
        formProps.resetField("name");
        formProps.resetField("options");
        fieldDetails.forEach(formProps.resetField);
      }
    }),
  };
}

export default useFormField;
